import React from 'react';

const ReadOnlyCartSummary = ({ orderData, finalPrice }) => {
  const subtotal = orderData?.subtotal || 0;
  const ayushpaySubtotal = orderData?.ayushpay_subtotal || 0;
  const deliveryCharges = orderData?.delivery_charges || 0;
  const handlingPackagingCharge = orderData?.handling_packaging_charge || 0;
  const platformCharge = orderData?.platform_charge || 0;
  const finalPayableAmount = finalPrice !== undefined && finalPrice !== null ? finalPrice : (orderData?.final_payable_amount || 0);

  return (
    <div className="mt-4 pt-4 border-t border-gray-200">
      {/* Order-level Charges */}
      <div className="space-y-2 mb-4">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-gray-700">Subtotal:</span>
          <span className="text-sm font-semibold text-gray-900">₹{parseFloat(subtotal).toFixed(2)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-gray-700">AyushPay Subtotal:</span>
          <span className="text-sm font-semibold text-blue-600">₹{parseFloat(ayushpaySubtotal).toFixed(2)}</span>
        </div>
        {deliveryCharges > 0 && (
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-700">Delivery Charge:</span>
            <span className="text-sm font-semibold text-gray-900">₹{parseFloat(deliveryCharges).toFixed(2)}</span>
          </div>
        )}
        {handlingPackagingCharge > 0 && (
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-700">Handling & Packaging Fee:</span>
            <span className="text-sm font-semibold text-gray-900">₹{parseFloat(handlingPackagingCharge).toFixed(2)}</span>
          </div>
        )}
        {platformCharge > 0 && (
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-700">Platform Fee:</span>
            <span className="text-sm font-semibold text-gray-900">₹{parseFloat(platformCharge).toFixed(2)}</span>
          </div>
        )}
      </div>
      {/* Final Total */}
      <div className="pt-3 border-t border-gray-300">
        <div className="flex justify-between items-center">
          <span className="text-lg font-semibold text-gray-900">Final Payable Amount:</span>
          <span className="text-lg font-semibold text-gray-900">₹{parseFloat(finalPayableAmount).toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyCartSummary;

